import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=a0a4de88"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=a0a4de88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports